<template>
  <div class="main-container innovation-awards-page">
    <page-header>{{ 'CSGCT 创新之星' | dealLanguage('CSGCT Innovation Awards') }}</page-header>
    <div class="awards-wrapper">
      <section class="hero-section">
        <div class="hero-content">
          <div class="hero-eyebrow">{{ pick(content.hero.eyebrow) }}</div>
          <h1 class="hero-title">{{ pick(content.hero.title) }}</h1>
          <p class="hero-desc">{{ pick(content.hero.desc) }}</p>
          <div class="hero-actions">
            <button class="action-btn primary" @click="scrollToSection('materials')">
              {{ pick(content.hero.buttons.apply) }}
            </button>
            <button class="action-btn ghost" @click="scrollToSection('eligibility')">
              {{ pick(content.hero.buttons.condition) }}
            </button>
            <button class="action-btn ghost" @click="goContact">
              {{ pick(content.hero.buttons.contact) }}
            </button>
          </div>
        </div>
        <div class="hero-visual" aria-hidden="true">
          <div class="halo halo-left"></div>
          <div class="halo halo-right"></div>
          <div class="trophy">
            <div class="cup-top"></div>
            <div class="cup-body"></div>
            <div class="cup-handle handle-left"></div>
            <div class="cup-handle handle-right"></div>
            <div class="cup-base"></div>
            <div class="cup-stand"></div>
            <div class="trophy-star">★</div>
          </div>
        </div>
      </section>

      <section class="section-card about-section">
        <div class="section-header">
          <span class="section-tag">01</span>
          <h2>{{ pick(content.about.title) }}</h2>
        </div>
        <div class="about-text">
          <p v-for="(item, index) in content.about.paragraphs" :key="'about-' + index">
            {{ pick(item) }}
          </p>
        </div>
      </section>

      <section ref="eligibility" class="section-card">
        <div class="section-header">
          <span class="section-tag">02</span>
          <h2>{{ pick(content.eligibility.title) }}</h2>
        </div>
        <div class="eligibility-grid">
          <div
            v-for="(item, index) in content.eligibility.items"
            :key="'eligibility-' + index"
            class="eligibility-card"
          >
            <div :class="['icon-box', item.icon]"></div>
            <h3>{{ pick(item.title) }}</h3>
            <p>{{ pick(item.desc) }}</p>
          </div>
        </div>
      </section>

      <section class="section-card">
        <div class="section-header">
          <span class="section-tag">03</span>
          <h2>{{ pick(content.applyTypes.title) }}</h2>
        </div>
        <div class="apply-type-grid">
          <div
            v-for="(item, index) in content.applyTypes.items"
            :key="'apply-type-' + index"
            class="apply-type-card"
          >
            <h3>{{ pick(item.title) }}</h3>
            <p v-for="(desc, descIndex) in item.desc" :key="'apply-desc-' + index + '-' + descIndex">
              {{ pick(desc) }}
            </p>
          </div>
        </div>
      </section>

      <section ref="materials" class="section-card">
        <div class="section-header">
          <span class="section-tag">04</span>
          <h2>{{ pick(content.materials.title) }}</h2>
        </div>
        <p class="section-intro">{{ pick(content.materials.intro) }}</p>
        <div class="form-card">
          <Form ref="current-form" :model="currentForm" :rules="ruleValidate" label-position="top">
            <Row :gutter="20">
              <Col span="12">
                <FormItem prop="fullName" :label="'公司全称' | dealLanguage('Company Full Name')">
                  <Input
                    v-model="currentForm.fullName"
                    type="text"
                    :placeholder="'请填写公司全称' | dealLanguage('Please fill in the company full name')"
                  ></Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem prop="shortName" :label="'公司简称' | dealLanguage('Company Short Name')">
                  <Input
                    v-model="currentForm.shortName"
                    type="text"
                    :placeholder="'请填写公司简称' | dealLanguage('Please fill in the company short name')"
                  ></Input>
                </FormItem>
              </Col>
            </Row>
            <Row :gutter="20">
              <Col span="12">
                <FormItem prop="name" :label="'联系人姓名' | dealLanguage('Contact Name')">
                  <Input
                    v-model="currentForm.name"
                    type="text"
                    :placeholder="'请填写联系人姓名' | dealLanguage('Please fill in the contact name')"
                  ></Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem prop="title" :label="'联系人职务' | dealLanguage('Contact Title')">
                  <Input
                    v-model="currentForm.title"
                    type="text"
                    :placeholder="'请填写联系人职务' | dealLanguage('Please fill in the contact title')"
                  ></Input>
                </FormItem>
              </Col>
            </Row>
            <Row :gutter="20">
              <Col span="12">
                <FormItem prop="mobile" :label="'联系人手机' | dealLanguage('Mobile Number')">
                  <Input
                    v-model="currentForm.mobile"
                    type="text"
                    :placeholder="'请输入联系人手机' | dealLanguage('Please enter the contact mobile number')"
                    autocomplete="off"
                  ></Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem prop="email" label="Email">
                  <Input
                    v-model="currentForm.email"
                    type="text"
                    :placeholder="'请填写邮箱' | dealLanguage('Please fill in your email')"
                  ></Input>
                </FormItem>
              </Col>
            </Row>
            <FormItem prop="compDesc" :label="'公司简介' | dealLanguage('Company Introduction')">
              <Input
                v-model="currentForm.compDesc"
                type="textarea"
                :rows="4"
                :placeholder="'请填写公司简介，介绍核心管线或技术平台' | dealLanguage('Please fill in the company introduction, including core pipeline or platform')"
              ></Input>
            </FormItem>
            <FormItem prop="content" :label="'创新说明' | dealLanguage('Innovation Statement')">
              <Input
                v-model="currentForm.content"
                type="textarea"
                :rows="6"
                :placeholder="'请填写创新说明，500字以内' | dealLanguage('Please fill in the innovation statement within 500 words')"
              ></Input>
              <div class="field-tip">
                <span>{{ pick(content.materials.exampleTitle) }}</span>
                <span :class="['word-count', innovationWordCount > 500 && 'danger']">
                  {{ innovationWordCount }}/500
                </span>
              </div>
            </FormItem>
            <FormItem prop="milestone" :label="'最新里程碑' | dealLanguage('Latest Milestones')">
              <Input
                v-model="currentForm.milestone"
                type="textarea"
                :rows="4"
                :placeholder="'请填写最新的临床、注册、融资、BD或合作进展' | dealLanguage('Please fill in the latest clinical, regulatory, financing, BD or partnership updates')"
              ></Input>
            </FormItem>
            <Row :gutter="20">
              <Col span="12">
                <FormItem prop="logoPath" :label="'公司 Logo' | dealLanguage('Company Logo')">
                  <div class="upload-wrapper">
                    <input
                      ref="logoInput"
                      class="file-input"
                      type="file"
                      accept=".png,.jpg,.jpeg,.webp"
                      @change="handleLogoChange"
                    />
                    <Button @click="triggerLogoSelect">
                      {{ '上传 Logo' | dealLanguage('Upload Logo') }}
                    </Button>
                    <span class="upload-text">
                      {{ '支持 PNG、JPG、JPEG、WEBP' | dealLanguage('Supports PNG, JPG, JPEG and WEBP') }}
                    </span>
                  </div>
                  <div class="upload-file" v-if="logoDisplayName">
                    <span>{{ logoDisplayName }}</span>
                    <Button type="text" @click="handleRemoveLogo">
                      {{ '删除' | dealLanguage('Remove') }}
                    </Button>
                  </div>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem :label="'附件（可选）' | dealLanguage('Attachment (Optional)')">
                  <div class="upload-wrapper">
                    <input
                      ref="attachmentInput"
                      class="file-input"
                      type="file"
                      accept=".png,.jpg,.jpeg,.pdf,.doc,.docx,.ppt,.pptx,.zip"
                      @change="handleAttachmentChange"
                    />
                    <Button @click="triggerAttachmentSelect">
                      {{ '上传附件' | dealLanguage('Upload Attachment') }}
                    </Button>
                    <span class="upload-text">
                      {{ '支持 PNG、JPG、JPEG、PDF、DOC、DOCX、PPT、PPTX、ZIP' | dealLanguage('Supports PNG, JPG, JPEG, PDF, DOC, DOCX, PPT, PPTX and ZIP') }}
                    </span>
                  </div>
                  <div class="upload-file" v-if="attachmentDisplayName">
                    <span>{{ attachmentDisplayName }}</span>
                    <Button type="text" @click="handleRemoveAttachment">
                      {{ '删除' | dealLanguage('Remove') }}
                    </Button>
                  </div>
                </FormItem>
              </Col>
            </Row>
            <div class="submit-btn-wrapper">
              <Button type="primary" class="submit-btn" :loading="buttonLoading" @click="handleSubmit">
                <span v-if="buttonLoading">{{ '提交中' | dealLanguage('Submitting') }}</span>
                <span v-else>{{ '提交申报' | dealLanguage('Submit Application') }}</span>
              </Button>
            </div>
          </Form>
        </div>
        <div class="example-card">
          <div class="example-title">{{ pick(content.materials.exampleTitle) }}</div>
          <p>{{ pick(content.materials.example) }}</p>
        </div>
      </section>

      <section class="section-card">
        <div class="section-header">
          <span class="section-tag">05</span>
          <h2>{{ pick(content.benefits.title) }}</h2>
        </div>
        <div class="benefit-grid">
          <div v-for="(item, index) in content.benefits.items" :key="'benefit-' + index" class="benefit-card">
            <h3>{{ pick(item.title) }}</h3>
            <ul>
              <li v-for="(line, lineIndex) in item.list" :key="'benefit-line-' + index + '-' + lineIndex">
                {{ pick(line) }}
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section class="section-card">
        <div class="section-header">
          <span class="section-tag">06</span>
          <h2>{{ pick(content.timeline.title) }}</h2>
        </div>
        <div class="timeline">
          <div class="timeline-line"></div>
          <div
            v-for="(item, index) in content.timeline.stages"
            :key="'timeline-' + index"
            class="timeline-item"
          >
            <div class="timeline-dot"></div>
            <div class="timeline-short">{{ pick(item.short) }}</div>
            <div class="timeline-card">
              <div class="timeline-time">{{ pick(item.time) }}</div>
              <div class="timeline-title">{{ pick(item.title) }}</div>
              <p>{{ pick(item.desc) }}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/pc/pageHeader.vue'
import content from './content'
import formMixin from './formMixin'
import { mapState } from 'vuex'
import filter from 'js/filter'

export default {
  mixins: [formMixin],
  metaInfo() {
    return {
      title: filter.dealLanguage('CSGCT 创新之星', 'CSGCT Innovation Awards'),
    }
  },
  components: {
    PageHeader,
  },
  data() {
    return {
      content,
    }
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
    }),
  },
  methods: {
    pick(item) {
      if (!item || typeof item !== 'object') return item || ''
      return this.language === 'en' ? item.en : item.zh
    },
    scrollToSection(refName) {
      const target = this.$refs[refName]
      if (target) {
        const top = target.getBoundingClientRect().top + window.pageYOffset - 64
        window.scrollTo({
          top: Math.max(top, 0),
          behavior: 'smooth',
        })
      }
    },
    goContact() {
      this.$router.push({
        name: 'contactUs',
        query: {
          language: this.language,
        },
      })
    },
  },
}
</script>

<style lang='stylus' scoped>
@import '~styles/common-pc.styl'

.awards-wrapper
  width 1180px
  margin 0 auto
  padding 30px 0 60px

.hero-section
  background linear-gradient(135deg, #3A0408 0%, #8F0E17 48%, #C8161D 100%)
  color #FFFFFF
  border-radius 28px
  padding 54px 60px
  display flex
  justify-content space-between
  align-items center
  gap 40px
  overflow hidden
  position relative
  box-shadow 0 24px 60px rgba(200, 22, 29, 0.22)

.hero-content
  position relative
  z-index 2
  flex 1

.hero-eyebrow
  display inline-flex
  align-items center
  padding 8px 16px
  border 1px solid rgba(255, 255, 255, 0.2)
  border-radius 999px
  font-size 14px
  line-height 20px
  letter-spacing 1px
  margin-bottom 18px
  background rgba(255, 255, 255, 0.08)

.hero-title
  font-size 48px
  line-height 64px
  font-weight 700
  max-width 620px

.hero-desc
  margin-top 18px
  font-size 18px
  line-height 32px
  color rgba(255, 255, 255, 0.86)
  max-width 640px

.hero-actions
  display flex
  gap 14px
  margin-top 32px
  flex-wrap wrap

.action-btn
  min-width 160px
  height 48px
  border-radius 999px
  border 1px solid transparent
  font-size 16px
  font-weight 600
  transition all .2s ease
  cursor pointer
  &.primary
    background #FFFFFF
    color #C8161D
    &:hover
      transform translateY(-1px)
      box-shadow 0 10px 24px rgba(0, 0, 0, 0.16)
  &.ghost
    background transparent
    color #FFFFFF
    border-color rgba(255, 255, 255, 0.28)
    &:hover
      background rgba(255, 255, 255, 0.08)

.hero-visual
  width 360px
  height 360px
  position relative
  flex 0 0 360px
  display flex
  align-items center
  justify-content center

.halo
  position absolute
  border-radius 50%
  filter blur(10px)
  opacity .8
  &.halo-left
    width 180px
    height 180px
    left 10px
    top 60px
    background rgba(255, 216, 120, 0.18)
  &.halo-right
    width 220px
    height 220px
    right 10px
    bottom 20px
    background rgba(255, 255, 255, 0.12)

.trophy
  position relative
  width 220px
  height 270px

.cup-top
  position absolute
  top 12px
  left 42px
  width 136px
  height 34px
  border-radius 999px
  background linear-gradient(180deg, #FFF7D8 0%, #F9D66D 100%)

.cup-body
  position absolute
  top 32px
  left 56px
  width 108px
  height 126px
  background linear-gradient(180deg, #FFF6D1 0%, #F2BE3E 54%, #C88A12 100%)
  clip-path polygon(14% 0%, 86% 0%, 100% 100%, 0% 100%)
  box-shadow inset 0 -8px 20px rgba(132, 78, 0, 0.25)

.cup-handle
  position absolute
  top 54px
  width 52px
  height 74px
  border 10px solid #F2C54E
  border-radius 50%
  &.handle-left
    left 16px
    border-right-color transparent
    transform rotate(-10deg)
  &.handle-right
    right 16px
    border-left-color transparent
    transform rotate(10deg)

.cup-base
  position absolute
  top 164px
  left 84px
  width 52px
  height 48px
  background linear-gradient(180deg, #FBE3A0 0%, #D89A1D 100%)
  clip-path polygon(30% 0%, 70% 0%, 100% 100%, 0% 100%)

.cup-stand
  position absolute
  top 206px
  left 58px
  width 104px
  height 26px
  border-radius 8px
  background linear-gradient(180deg, #7A161B 0%, #4F080B 100%)
  box-shadow 0 8px 24px rgba(0, 0, 0, 0.2)

.trophy-star
  position absolute
  top 72px
  left 96px
  font-size 34px
  line-height 1
  color #FFFFFF
  text-shadow 0 4px 10px rgba(0, 0, 0, 0.16)

.section-card
  margin-top 28px
  background #FFFFFF
  border-radius 24px
  padding 34px 36px
  box-shadow 0 10px 30px rgba(17, 17, 17, 0.04)

.section-header
  display flex
  align-items center
  gap 16px
  margin-bottom 22px
  h2
    font-size 28px
    line-height 40px
    color #2D1A1B
    font-weight 700

.section-tag
  width 48px
  height 48px
  border-radius 14px
  background rgba(200, 22, 29, 0.08)
  color #C8161D
  display inline-flex
  align-items center
  justify-content center
  font-size 18px
  font-weight 700

.section-intro
  font-size 16px
  line-height 28px
  color #666666
  margin-bottom 20px

.form-card
  padding 28px
  border-radius 22px
  background linear-gradient(180deg, #FFF9F9 0%, #FFFFFF 100%)
  border 1px solid #F0DDDE
  /deep/.ivu-form-item-label
    color #2D1A1B
    font-size 14px
    line-height 22px
    margin-bottom 6px
  /deep/.ivu-input,
  /deep/.ivu-select-selection,
  /deep/.ivu-input-wrapper textarea.ivu-input
    border-color #E8D5D7
  /deep/.ivu-input:focus,
  /deep/.ivu-input:hover,
  /deep/.ivu-select-selection:hover,
  /deep/.ivu-select-visible .ivu-select-selection
    border-color #C8161D
    box-shadow none
  /deep/.ivu-form-item
    margin-bottom 22px

.field-tip
  margin-top 8px
  display flex
  justify-content space-between
  gap 12px
  font-size 12px
  line-height 18px
  color #999999
  .word-count
    color #666666
    &.danger
      color #ED4014

.upload-wrapper
  display flex
  align-items center
  gap 12px
  flex-wrap wrap
  .file-input
    display none
  .upload-text
    font-size 12px
    line-height 20px
    color #999999

.upload-file
  margin-top 10px
  min-height 32px
  display flex
  align-items center
  justify-content space-between
  gap 12px
  padding 8px 12px
  border-radius 10px
  background #FFF3F3
  color #5A5A5A

.submit-btn-wrapper
  padding-top 8px
  text-align center

.submit-btn
  min-width 220px
  height 44px
  background #C8161D
  border-color #C8161D
  &:hover
    background #E24147
    border-color #E24147


.about-text
  display grid
  grid-template-columns repeat(2, 1fr)
  gap 18px
  p
    margin 0
    font-size 16px
    line-height 30px
    color #4A4A4A

.eligibility-grid
  display grid
  grid-template-columns repeat(4, 1fr)
  gap 18px

.eligibility-card
  padding 24px 20px
  border-radius 20px
  background linear-gradient(180deg, #FFF8F8 0%, #FFFFFF 100%)
  border 1px solid #F4DFE0
  h3
    margin-top 18px
    font-size 20px
    line-height 28px
    color #2D1A1B
    font-weight 700
  p
    margin-top 10px
    font-size 14px
    line-height 24px
    color #666666

.icon-box
  width 54px
  height 54px
  border-radius 16px
  background linear-gradient(135deg, #FCE6E7 0%, #F7C6C9 100%)
  position relative
  &:before
    content ''
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
    background #C8161D
  &.enterprise:before
    width 22px
    height 18px
    border-radius 4px 4px 2px 2px
    box-shadow 0 -8px 0 -4px #C8161D, -8px 8px 0 -6px #C8161D, 8px 8px 0 -6px #C8161D
  &.innovation:before
    width 18px
    height 18px
    border-radius 50%
    box-shadow 0 -12px 0 -6px #C8161D, 0 12px 0 -6px #C8161D, -12px 0 0 -6px #C8161D, 12px 0 0 -6px #C8161D
  &.trust:before
    width 18px
    height 24px
    clip-path polygon(50% 0%, 100% 18%, 100% 55%, 50% 100%, 0% 55%, 0% 18%)
  &.material:before
    width 20px
    height 24px
    border-radius 4px
    box-shadow 0 -8px 0 -6px #FFFFFF inset

.apply-type-grid
  display grid
  grid-template-columns repeat(2, 1fr)
  gap 20px

.apply-type-card
  border-radius 20px
  background linear-gradient(180deg, #FFF6F6 0%, #FFFFFF 100%)
  border 1px solid #F3D9DB
  padding 26px
  h3
    font-size 24px
    line-height 34px
    color #C8161D
    margin-bottom 12px
  p
    font-size 15px
    line-height 28px
    color #5A5A5A
    & + p
      margin-top 8px

.materials-grid
  display grid
  grid-template-columns repeat(2, 1fr)
  gap 14px 18px

.material-item
  border 1px solid #F0E0E1
  border-radius 18px
  padding 18px
  display flex
  gap 14px
  background #FFFCFC

.material-index
  width 34px
  height 34px
  border-radius 50%
  background #C8161D
  color #FFFFFF
  display inline-flex
  align-items center
  justify-content center
  font-size 16px
  font-weight 700
  flex 0 0 34px

.material-title
  font-size 16px
  line-height 24px
  color #2D1A1B
  font-weight 600

.material-note
  margin-top 6px
  font-size 14px
  line-height 24px
  color #7A7A7A

.example-card
  margin-top 22px
  padding 22px 24px
  border-radius 20px
  background linear-gradient(135deg, rgba(200, 22, 29, 0.05) 0%, rgba(200, 22, 29, 0.01) 100%)
  border 1px dashed rgba(200, 22, 29, 0.28)
  .example-title
    font-size 18px
    line-height 28px
    color #C8161D
    font-weight 700
    margin-bottom 10px
  p
    font-size 14px
    line-height 26px
    color #5A5A5A

.benefit-grid
  display grid
  grid-template-columns repeat(2, 1fr)
  gap 20px

.benefit-card
  background linear-gradient(180deg, #FFF8F8 0%, #FFFFFF 100%)
  border-radius 20px
  border 1px solid #F2E0E1
  padding 26px
  h3
    font-size 24px
    line-height 34px
    color #2D1A1B
    margin-bottom 14px
  ul
    padding-left 18px
  li
    font-size 15px
    line-height 28px
    color #5A5A5A
    & + li
      margin-top 6px

.timeline
  position relative
  display grid
  grid-template-columns repeat(5, 1fr)
  gap 16px

.timeline-line
  position absolute
  top 18px
  left 10%
  right 10%
  height 2px
  background linear-gradient(90deg, rgba(200, 22, 29, 0.2) 0%, rgba(200, 22, 29, 0.8) 100%)

.timeline-item
  position relative
  z-index 1

.timeline-dot
  width 18px
  height 18px
  border-radius 50%
  background #C8161D
  box-shadow 0 0 0 6px rgba(200, 22, 29, 0.12)
  margin 0 auto

.timeline-short
  margin-top 12px
  font-size 14px
  line-height 20px
  color #C8161D
  text-align center
  font-weight 700

.timeline-card
  margin-top 14px
  padding 18px 18px 20px
  border-radius 18px
  background #FFF9F9
  border 1px solid #F2DEDF
  min-height 170px
  .timeline-time
    font-size 14px
    line-height 20px
    color #C8161D
    font-weight 700
  .timeline-title
    margin-top 8px
    font-size 18px
    line-height 26px
    color #2D1A1B
    font-weight 700
  p
    margin-top 8px
    font-size 14px
    line-height 24px
    color #666666
</style>
